module.exports = __webpack_public_path__ + "static/media/top-millionaires-active-dark-icon.00e88ec3.svg";